// extracted by mini-css-extract-plugin
export default {"child":"multi_page-module___child___ade0773a","visible":"multi_page-module___visible___afc17684"};